export default entity => async dispatch => {
  dispatch({
    type: "COLLECTIONS/ENTITY/UPDATE",
    payload: { entity: entity }
  });
};
